"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthCapabilities = exports.AppUrlSchemes = exports.Platforms = exports.ClientType = exports.Source = void 0;
var Source;
(function (Source) {
    Source["LOGIN"] = "login";
    Source["REGISTRATION"] = "registration";
})(Source || (exports.Source = Source = {}));
var ClientType;
(function (ClientType) {
    ClientType["WEB"] = "web";
    ClientType["MOBILE"] = "mobile";
})(ClientType || (exports.ClientType = ClientType = {}));
var Platforms;
(function (Platforms) {
    Platforms["ML"] = "ML";
    Platforms["MP"] = "MP";
})(Platforms || (exports.Platforms = Platforms = {}));
var AppUrlSchemes;
(function (AppUrlSchemes) {
    AppUrlSchemes["ML"] = "meli:";
    AppUrlSchemes["MP"] = "mercadopago:";
})(AppUrlSchemes || (exports.AppUrlSchemes = AppUrlSchemes = {}));
var AuthCapabilities;
(function (AuthCapabilities) {
    AuthCapabilities["GOOGLE_ONE_TAP"] = "google_one_tap";
    AuthCapabilities["GOOGLE_BUTTON"] = "google_button";
})(AuthCapabilities || (exports.AuthCapabilities = AuthCapabilities = {}));
